exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".chosen-app {\n  border-style: groove;\n}\n", ""]);

